import React, { useEffect, useState } from "react";
import { UploadCloud, FileText } from "lucide-react";
import toast from "react-hot-toast";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import formatDateAndTime from "../../common/formatDateAndTime";
import formatDate from "../../common/Formatdate";

export default function Legal({ workOrderDetail, handleImageOpen }) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [form, setForm] = useState({
    caseId: "",
    vehicleNumber: workOrderDetail?.licensePlate,
    accidentDate: "",
    firNumber: "",
    policeStation: "",
    status: "",
    hearingDate: "",
    accidentPlace: "",
    courtAddress: "",
    description: "",
    attachments: [],
    caseId: "",
    nextHearingDate: "",
    remarks: "",
  });
  const [casePostResponse, setCasePostResponse] = useState(null);
  const [legalThreads, setLegalThreads] = useState([]);

  const handleFileChange = async (files) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded || [];

    setForm((prev) => ({
      ...prev,
      attachments: [...(prev.attachments || []), ...uploaded],
    }));
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getLegalCaseDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleaccidentcases?workorderId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (
        data?.statusCode === "0100" &&
        Object.entries(data?.entities?.rows[0]).length > 0
      ) {
        setCasePostResponse(data?.entities?.rows[0]);
      } else {
        setCasePostResponse(null);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getLegalCaseThreads = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleaccidentthreads?caseId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLegalThreads(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  useEffect(() => {
    if (workOrderDetail?.id) {
      getLegalCaseDetails(workOrderDetail?.id);
    }
  }, [workOrderDetail]);

  useEffect(() => {
    if (casePostResponse?.id) {
      getLegalCaseThreads(casePostResponse?.id);
    }
  }, [casePostResponse]);

  const validateCaseForm = () => {
    if (!form?.vehicleNumber) return "Vehicle number is required";
    if (!form?.accidentDate) return "Accident date is required";
    if (!form?.firNumber) return "FIR number is required";
    if (!form?.policeStation) return "Police station is required";
    if (!form?.status) return "Status is required";
    if (!form?.hearingDate) return "Hearing Date is required";
    if (!form?.accidentPlace) return "Place of Incident is required";

    // if (form?.hearingDate && form?.hearingDate < form?.accidentDate) {
    //   return "Hearing date cannot be before accident date";
    // }

    if (!form?.attachments || form.attachments.length === 0) {
      return "At least one attachment is required";
    }

    return null;
  };

  const handleCaseDetails = async () => {
    const error = validateCaseForm();

    if (error) {
      toast.error(error);
      return;
    }
    let payload;

    payload = {
      caseId: form?.caseId,
      vehicleNumber: form?.vehicleNumber,
      accidentDate: form?.accidentDate,
      hearingDate: form?.hearingDate,
      remarks: form?.description,
      firNumber: form?.firNumber,
      policeStation: form?.policeStation,
      placeOfAccident: form?.accidentPlace,
      courtNameAndAddress: form?.courtAddress,
      status: form?.status,
      attachments: JSON.stringify(form?.attachments),
      workorderId: workOrderDetail?.id,
      vehicleId: workOrderDetail?.vehicleId,
      historyObject: { summary: `Case created with status ${form?.status}` },
    };

    try {
      const res = await fetch(`${apiUrl}/api/vehicleaccidentcases`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("New Part Added Successfully 🎉");
        setCasePostResponse(data?.dataValues);
        // await getVehiclePartCatalogs();
        setForm({
          caseId: "",
          vehicleNumber: workOrderDetail?.licensePlate,
          accidentDate: "",
          firNumber: "",
          policeStation: "",
          status: "",
          hearingDate: "",
          accidentPlace: "",
          courtAddress: "",
          description: "",
          attachments: [],
          caseId: "",
          nextHearingDate: "",
          remarks: "",
        });
      }
    } catch (err) {
      toast.error("Something went wrong in add legal case");
    }
  };

  const handleCaseThreadDetails = async () => {
    let payload;

    payload = {
      status: form?.status,
      nextHearingDate: form?.nextHearingDate,
      remarks: form?.remarks,
      attachments: JSON.stringify(form?.attachments),
      caseId: casePostResponse?.id,
      historyObject: { summary: form?.remarks, caseId: casePostResponse?.id },
    };

    try {
      const res = await fetch(`${apiUrl}/api/vehicleaccidentthreads`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("New Part Added Successfully 🎉");
        setForm({
          caseId: "",
          vehicleNumber: workOrderDetail?.licensePlate,
          accidentDate: "",
          firNumber: "",
          policeStation: "",
          status: "",
          hearingDate: "",
          accidentPlace: "",
          courtAddress: "",
          description: "",
          attachments: [],
          caseId: "",
          nextHearingDate: "",
          remarks: "",
        });
        // setCasePostResponse(data?.dataValues);
        await getLegalCaseThreads(casePostResponse?.id);
      }
    } catch (err) {
      toast.error("Something went wrong in threads");
    }
  };

  const getFileType = (url) => {
    if (!url) return "";

    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (["pdf"].includes(ext)) return "pdf";
    if (["doc", "docx"].includes(ext)) return "doc";

    return "other";
  };

  return (
    <div className="min-h-screen text-white">
      <div className="max-w-7xl mx-auto bg-gray-800 rounded-2xl shadow-lg p-6">
        <h2 className="text-2xl font-semibold mb-6">Legal Case Details</h2>

        {!casePostResponse ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Input
                label="Case ID"
                value={form.caseId}
                onChange={(v) => handleChange("caseId", v)}
              />
              <Input
                label="Vehicle Number"
                value={form.vehicleNumber}
                onChange={(v) => handleChange("vehicleNumber", v)}
              />

              <Input
                type="date"
                label="Accident Date"
                value={form.accidentDate}
                onChange={(v) => handleChange("accidentDate", v)}
              />
              <Input
                label="FIR Number"
                value={form.firNumber}
                onChange={(v) => handleChange("firNumber", v)}
              />

              <Input
                label="Police Station"
                value={form.policeStation}
                onChange={(v) => handleChange("policeStation", v)}
              />
              <div>
                <label className="block text-sm mb-1">Status</label>
                <select
                  value={form.status}
                  onChange={(e) => handleChange("status", e.target.value)}
                  className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                >
                  <option value="">Select Status</option>
                  <option value="Open">Open</option>
                  <option value="Under Investigation">
                    Under Investigation
                  </option>
                  <option value="Hearing Scheduled">Hearing Scheduled</option>
                  <option value="Closed">Closed</option>
                </select>
              </div>

              <Input
                type="date"
                label="Hearing Date"
                value={form.hearingDate}
                onChange={(v) => handleChange("hearingDate", v)}
              />
            </div>

            <div className="mt-4">
              <TextArea
                label="Accident Place (Complete Address)"
                value={form.accidentPlace}
                onChange={(v) => handleChange("accidentPlace", v)}
              />
            </div>

            <div className="mt-4">
              <TextArea
                label="Court Name & Address"
                value={form.courtAddress}
                onChange={(v) => handleChange("courtAddress", v)}
              />
            </div>

            <div className="mt-4">
              <TextArea
                label="Description"
                value={form.description}
                onChange={(v) => handleChange("description", v)}
              />
            </div>

            <div className="mt-6">
              <label className="block mb-2 text-sm font-medium">
                Attachments
              </label>
              <div className="border-2 border-dashed border-gray-600 rounded-xl p-6 text-center cursor-pointer hover:border-gray-400">
                <input
                  type="file"
                  multiple
                  className="hidden"
                  id="fileUpload"
                  onChange={(e) => handleFileChange(e.target.files)}
                />
                <label
                  htmlFor="fileUpload"
                  className="cursor-pointer flex flex-col items-center"
                >
                  <UploadCloud size={32} />
                  <p className="text-sm mt-2">Click to upload files</p>
                </label>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                {form.attachments.map((file, idx) => (
                  <div key={idx} className="bg-gray-700 p-2 rounded-lg">
                    <img
                      src={file.url || file?.Location || file?.path || file}
                      alt="preview"
                      className="w-full h-24 object-cover rounded"
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button
                onClick={() => {
                  handleCaseDetails();
                }}
                className="bg-teal-600 hover:bg-teal-700 px-6 py-2 rounded-xl text-sm"
              >
                Submit Case
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="mt-2 rounded-xl">
              <div className="bg-white shadow-md rounded-2xl p-6 border">
                {/* <h2 className="text-lg font-semibold mb-4">Case Details</h2> */}

                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                  <Detail label="Case ID" value={casePostResponse?.caseId} />
                  <Detail
                    label="Vehicle"
                    value={casePostResponse?.vehicleNumber}
                  />
                  <Detail label="FIR No" value={casePostResponse?.firNumber} />

                  <Detail
                    label="Accident Date"
                    value={casePostResponse?.accidentDate}
                  />
                  <Detail label="Status" value={casePostResponse?.status} />
                  <Detail
                    label="Police Station"
                    value={casePostResponse?.policeStation}
                  />

                  <Detail
                    label="Place of Incident"
                    value={casePostResponse?.placeOfAccident}
                  />

                  <Detail
                    label="Case Summary"
                    value={casePostResponse?.remarks}
                    fullWidth
                  />

                  {/* Attachments */}
                  <div className="col-span-1 md:col-span-3">
                    <p className="text-sm text-gray-500 mb-2">Attachments</p>

                    {casePostResponse?.attachments?.length > 0 ? (
                      <div className="grid grid-cols-4 gap-4">
                        {JSON.parse(casePostResponse?.attachments).map(
                          (file, index) => {
                            const fileUrl =
                              file?.url || file?.path || file?.Location || file;

                            const type = getFileType(fileUrl);

                            return (
                              <div
                                key={index}
                                className="border rounded-lg p-2 cursor-pointer hover:bg-gray-100"
                                onClick={() => handleImageOpen(fileUrl)}
                              >
                                {type === "image" && (
                                  <img
                                    src={fileUrl}
                                    alt={`Attachment ${index + 1}`}
                                    className="w-full h-24 object-cover rounded"
                                  />
                                )}

                                {type === "video" && (
                                  <video
                                    src={fileUrl}
                                    className="w-full h-24 object-cover rounded"
                                    controls
                                  />
                                )}

                                {type === "pdf" && (
                                  <div className="text-center text-sm text-red-500">
                                    📄 PDF File
                                  </div>
                                )}

                                {type === "doc" && (
                                  <div className="text-center text-sm text-blue-500">
                                    📝 Document
                                  </div>
                                )}

                                {type === "other" && (
                                  <div className="text-center text-sm text-gray-500">
                                    📁 File
                                  </div>
                                )}
                              </div>
                            );
                          },
                        )}
                      </div>
                    ) : (
                      <p className="text-sm text-gray-400">No attachments</p>
                    )}
                  </div>
                </div>
              </div>

              {legalThreads?.length > 0 && (
                <div className="overflow-x-auto mt-4">
                  <table className="min-w-full border border-gray-200 rounded-lg">
                    <thead className="bg-gray-100 text-gray-600 text-sm">
                      <tr>
                        <th className="p-3 text-left border">Status</th>
                        <th className="p-3 text-left border">
                          Next Hearing Date
                        </th>
                        <th className="p-3 text-left border">Remarks</th>
                        <th className="p-3 text-left border">Created at</th>
                        <th className="p-3 text-left border">Attachments</th>
                      </tr>
                    </thead>

                    <tbody>
                      {legalThreads.map((thread, idx) => {
                        let attachments = [];

                        try {
                          attachments =
                            typeof thread?.attachments === "string"
                              ? JSON.parse(thread.attachments)
                              : thread?.attachments || [];
                        } catch (e) {
                          attachments = [];
                        }

                        return (
                          <tr key={idx} className="text-sm">
                            <td className="p-3 border">
                              {thread?.status || "-"}
                            </td>

                            <td className="p-3 border">
                              {formatDate(thread?.nextHearingDate) || "-"}
                            </td>

                            <td className="p-3 border">
                              {thread?.remarks || "-"}
                            </td>

                            <td className="p-3 border">
                              {formatDateAndTime(thread?.createdAt) || "-"}
                            </td>

                            <td className="p-3 border">
                              {attachments.length > 0 ? (
                                <div className="flex gap-2 flex-wrap">
                                  {attachments.map((file, index) => {
                                    const url =
                                      file?.url ||
                                      file?.path ||
                                      file?.Location ||
                                      file;

                                    const type = getFileType(url);

                                    return (
                                      <div
                                        key={index}
                                        onClick={() => handleImageOpen(url)}
                                        className="w-16 h-16 flex items-center justify-center border rounded-md cursor-pointer hover:scale-105 transition bg-gray-50"
                                      >
                                        {type === "image" && (
                                          <img
                                            src={url}
                                            alt={`Attachment ${index + 1}`}
                                            className="w-full h-full object-cover rounded-md"
                                          />
                                        )}

                                        {type === "video" && (
                                          <video
                                            src={url}
                                            className="w-full h-full object-cover rounded-md"
                                          />
                                        )}

                                        {type === "pdf" && (
                                          <span className="text-xs text-red-500 text-center">
                                            📄 PDF
                                          </span>
                                        )}

                                        {type === "doc" && (
                                          <span className="text-xs text-blue-500 text-center">
                                            📝 DOC
                                          </span>
                                        )}

                                        {type === "other" && (
                                          <span className="text-xs text-gray-500 text-center">
                                            📁 File
                                          </span>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              ) : (
                                <span className="text-gray-400">
                                  No attachments
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="mt-6 bg-gray-900 p-6 rounded-xl">
              <h3 className="text-xl font-semibold mb-4">Update Case</h3>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm mb-1">Status</label>
                  <select
                    onChange={(e) => handleChange("status", e.target.value)}
                    className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-sm"
                  >
                    <option value="">Select Status</option>
                    <option value="Open">Open</option>
                    <option value="Under Investigation">
                      Under Investigation
                    </option>
                    <option value="Hearing Scheduled">Hearing Scheduled</option>
                    <option value="Closed">Closed</option>
                  </select>
                </div>

                <Input
                  type="date"
                  label="Next Hearing Date"
                  onChange={(v) => handleChange("nextHearingDate", v)}
                />

                <Input
                  label="Remark"
                  onChange={(v) => handleChange("remarks", v)}
                />
              </div>

              <div className="mt-6">
                <label className="block mb-2 text-sm font-medium">
                  Attachments
                </label>
                <div className="border-2 border-dashed border-gray-600 rounded-xl p-6 text-center cursor-pointer hover:border-gray-400">
                  <input
                    type="file"
                    multiple
                    className="hidden"
                    id="fileUploadUpdate"
                    onChange={(e) => handleFileChange(e.target.files)}
                  />
                  <label
                    htmlFor="fileUploadUpdate"
                    className="cursor-pointer flex flex-col items-center"
                  >
                    <UploadCloud size={32} />
                    <p className="text-sm mt-2">Click to upload files</p>
                  </label>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                  {form.attachments.map((file, idx) => (
                    <div key={idx} className="bg-gray-700 p-2 rounded-lg">
                      <img
                        src={file.url || file?.Location || file?.path || file}
                        alt="preview"
                        className="w-full h-24 object-cover rounded"
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex justify-end mt-6">
                <button
                  onClick={() => {
                    handleCaseThreadDetails();
                  }}
                  className="bg-yellow-600 hover:bg-yellow-700 px-6 py-2 rounded-xl text-sm"
                >
                  Update Case
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function Input({ label, value, onChange, type = "text" }) {
  return (
    <div>
      <label className="block text-sm mb-1">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
      />
    </div>
  );
}

function TextArea({ label, value, onChange }) {
  return (
    <div>
      <label className="block text-sm mb-1">{label}</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
      />
    </div>
  );
}

function Detail({ label, value, fullWidth }) {
  return (
    <div className={fullWidth ? "md:col-span-3" : ""}>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="text-sm font-medium text-gray-800 break-words">
        {value || "-"}
      </p>
    </div>
  );
}
